import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, ApiError } from "@zentrani/api-client";
import { Alert, Button, Field, Input, Logo, PasswordInput } from "@zentrani/ui";
import { homeFor } from "../lib/homeFor";
import { isSafeShareNext } from "../lib/shareLink";
import { useSession } from "../state/session";

export function LoginPage() {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { apply } = useSession();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const session = await api.auth.login(identifier, password);
      apply(session);
      const next = params.get("next");
      navigate(isSafeShareNext(next) ? next : homeFor(session.role), { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.detail : "No se pudo iniciar sesión.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="grid min-h-dvh place-items-center bg-slate-50 px-4">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex justify-center">
          <Logo sub />
        </div>
        <form onSubmit={submit} className="rounded-2xl bg-white p-6 shadow-card ring-1 ring-slate-900/5">
          <h1 className="text-xl font-bold text-ink">Iniciar sesión</h1>
          <p className="mt-1 text-sm text-ink-muted">Accedé al portal de tu comunidad.</p>
          <div className="mt-5 space-y-4">
            <Field label="Email o teléfono" required>
              <Input
                required
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                placeholder="tu@correo.com"
                autoComplete="username"
              />
            </Field>
            <Field label="Contraseña" required>
              <PasswordInput
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </Field>
            <p className="text-right text-sm">
              <Link className="text-brand-700 underline" to="/recuperar">
                ¿Olvidaste tu contraseña?
              </Link>
            </p>
            <Button type="submit" block size="lg" loading={loading}>
              Entrar
            </Button>
            {error ? <Alert tone="stop">{error}</Alert> : null}
          </div>
        </form>
        <p className="mt-4 text-center text-xs text-ink-muted">
          ¿Sos visitante ocasional? Usá el enlace temporal que te envió el residente.
        </p>
      </div>
    </div>
  );
}
